import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import {Popover} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import {closeContextMenu} from "./contextMenu.slice";
import request from "../../../../../Services/API/Requests";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import SideBarTree from "../../../../SideBarNew/SideBarTree";
import {TreeView} from "@material-ui/lab";
import {findActions} from "../Menu/Menu";
import findByString from "../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import getParamsFromString from "../../../Utils/getParamsFromString";
import {executeBool} from "../../../../../Utils/Form/FormDynamic/Utils/checkHidden";
import CircularProgress from "@material-ui/core/CircularProgress";

const ContextMenu = (props) => {
    const {doActions, component, screenName} = props;
    const {globalValues} = useSelector(state => state.jsonScreen)
    const {anchor, anchorTarget, currentId, actionContext} = useSelector(state => state.contextMenu);
    const [values, setValues] = useState([]);
    const dispatch = useDispatch();
    const {
        properties: {
            context,
            type
        } = {},
        styles: sourceStyles = [{}]
    } = component;
    const [menuStyles, dropdownItemStyles] = sourceStyles;
    useEffect(() => {
        if(context) {
            request({
                url: 'menu/read',
                data: {id: context}
            }).then(res => {
                setValues(res.main)
            }).catch(e => {
                console.log('context read error', e)
            })
        }

    }, [])

    function onClose() {
        dispatch(closeContextMenu())
    }

    function onMenuItemSelect(nodeId) {
        const menuItem = findByString(values, `${nodeId}`) || {properties: {}};
        if (menuItem.properties.disabledCondition) {
            const isDisabled = executeBool({...globalValues, ...actionContext},
                menuItem.properties.disabledCondition, screenName)
            if (isDisabled) return;
        }
        const {url, anchor} = menuItem.properties || {};
        const executedUrl = getParamsFromString(url, globalValues, screenName)
        const actions = findActions(menuItem, executedUrl, anchor);

        if (actions) {
            doActions(actions, actionContext, null, screenName)
        }

        //don't close context when clicked parent item
        if (menuItem.sub) return

        onClose();
    }

    return (
        <>
            <Popover open={Boolean(Boolean(anchor.mouseX) && (currentId === component?.properties?.context))}
                     onClose={onClose}
                     anchorEl={type === 'component' ? anchorTarget : undefined}
                     anchorReference={type === 'component' ? 'anchorEl' : "anchorPosition"}
                     anchorPosition={anchor.mouseY !== null && anchor.mouseX !== null
                         ? {top: anchor.mouseY, left: anchor.mouseX}
                         : undefined}
                     anchorOrigin={{
                         horizontal: 'right',
                         vertical: 'bottom'
                     }}
                     transformOrigin={{
                         vertical: 'top',
                         horizontal: 'center',
                     }}
            >
                {anchor.mouseX !== null && !values.length && (
                    <div style={{height: 50, width: 50}}>
                        <CircularProgress className="loading-icon-mui" size={20}/>
                    </div>
                )}
                <TreeView
                    // className={classes.treeViewRoot}
                    // selected={selected}

                    onNodeSelect={(e, nodeId) => onMenuItemSelect(nodeId)}
                    defaultCollapseIcon={<ArrowDropDownIcon/>}
                    defaultExpandIcon={<ArrowRightIcon/>}
                    defaultEndIcon={<div style={{width: 24}}/>}
                >
                    {SideBarTree({
                        menu: values,
                        onKeyDownItem: () => {
                        },
                        screenName: '',
                        dropdownItemStyles,
                        menuStyles,
                        doActions,
                        actionContext
                    })}
                </TreeView>
            </Popover>
        </>
    )
};

export default ContextMenu

ContextMenu.propTypes = {
    doActions: PropTypes.func,
    screenName: PropTypes.string
};